import { Component, OnInit, Input, Output, EventEmitter, ViewChildren, AfterViewInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'app-adddoctypepopup',
  templateUrl: './adddoctypepopup.component.html',
  styleUrls: ['./adddoctypepopup.component.css']
})
export class AdddoctypepopupComponent implements OnInit {

  @ViewChildren('input') firstipcontrol;

  formname: string = "Doctype";

  //Display
  formmode: string = "Add";

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;


  //Save Validation
  submitted: boolean;
  successfully: boolean;

  saveloading: boolean;

  //Edit Get Values
  doctypeColl: any = [];
  doctypeBO: any = {};
  doctypeid: number = 0

  alerttypeColl: any = [];

  doctypeform = new FormGroup({
    doctypeid: new FormControl(0),
    doctypename: new FormControl('', Validators.required),
    alertdaysbefore: new FormControl(null),
    alerttypeid: new FormControl(null),
    inactive: new FormControl(false),
    isexpirydt: new FormControl(false),
    isissuedt: new FormControl(false),
    isdocnum: new FormControl(false),
    ismandatory: new FormControl(false),
    isunique: new FormControl(false),
    iscompany: new FormControl(false),
    isemployee: new FormControl(false),

  });

  @Output() emitData = new EventEmitter();

  constructor(private appService: AppdataService, private loginService: LoginserviceService, private route: ActivatedRoute,
    public router: Router, private toastr: ToastrService, private activeModal: NgbActiveModal,) {

    this.fnServiceChanges();
  }
    


  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.fnUserFailedForm();
      }

    });
  }



  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.doctypeform.reset();
      this.fnInitializeFormGroup();

      this.fngetAlertType();
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.doctypeid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }
  ngAfterViewInit() {
    //this.firstipcontrol.first.nativeElement.focus();
  }
  fnInitializeFormGroup() {
    this.doctypeform.setValue({
      doctypeid: 0,
      doctypename: '',
      alertdaysbefore: null,
      alerttypeid: null,
      isexpirydt: false,
      isissuedt: false,
      isdocnum: false,
      ismandatory: false,
      isunique: false,
      iscompany: false,
      isemployee: false,
      inactive: false
    })
  }



  fngetAlertType() {
    var data = {
      'alerttypeid': 0,
      'companyid': this.loginService.fnGetCompanyId()
    }
    this.appService.getAlerttype(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.alerttypeColl = res.json().result;
          }
          else {
            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  //Save Btn Click
  fnSaveBtnClick() {
    try {
      if (this.saveloading) {
        return;        
    }
    
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.doctypeform.valid) {
        //Check
        this.saveloading = true;

        var data = {
          'doctypeid': this.doctypeid,
          'doctypename': this.doctypeform.get('doctypename').value,
          'alertdaysbefore': this.doctypeform.get('alertdaysbefore').value,
          'alerttypeid': this.doctypeform.get('alerttypeid').value,
          'isexpirydt': this.doctypeform.get('isexpirydt').value,
          'isissuedt': this.doctypeform.get('isissuedt').value,
          'isdocnum': this.doctypeform.get('isdocnum').value,
          'ismandatory': this.doctypeform.get('ismandatory').value,
          'isunique': this.doctypeform.get('isunique').value,
          'iscompany': this.doctypeform.get('iscompany').value,
          'isemployee': this.doctypeform.get('isemployee').value,
          'inactive': this.doctypeform.get('inactive').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }


        this.appService.fnCheckDocType(data).subscribe(
          (res) => {
            if (res.json().status === 200) {
              var _checkresult = res.json().result[0].checkfield;

              if (_checkresult === "done") {
               
           
                  //Insert 
                  this.fnInsertDoctype(data);
     
              }
              else {
                if (_checkresult === "name") {
                  this.saveloading = false;

                  this.doctypeform.controls['doctypename'].setErrors({ 'notfound': true });
                }
              }
            }
            else {
              this.saveloading = false;

              this.loginService.fnAPIError(res.json())
            }
          },
          (err) => {
            this.saveloading = false;

            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.saveloading = false;

      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertDoctype(data) {

    this.appService.fnInsertDocType(data).subscribe(
      (res) => {
        this.saveloading = false;

        if (res.json().status === 200) {
          if (res.json().result != "") {

           
            console.log( res.json())
            this.toastr.success('', "The new doctype has been added successfully.Insert Successfully");
            this.fnInsertActivityLog('INSERT', 0, data.doctypeid);
            var result = res.json().result;
            
            var doctypeid = 0;
            if (result.length > 0) {
              doctypeid = result[0].doctypeid
            }
            this.emitData.emit(doctypeid);
            this.activeModal.close(true);
  

          }  
          else {
            this.loginService.fnAPIError(res.json())
          }
        }
        (err) => {
          this.saveloading = false;        
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });

  }

  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch{

    }
  }
  public decline() {
    this.activeModal.close(false);
  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }


}

